import { Component, EventEmitter, Input, Output, OnChanges, SimpleChanges } from '@angular/core';
import { AccountService } from '../../account/account.service';
import { Kit } from 'src/app/models';
import {NgxSpinnerService} from 'ngx-spinner';
import {ToastrService} from 'ngx-toastr';

@Component({
  selector: 'app-image-view',
  templateUrl: './image-view-component.html',
  styleUrls: ['./image-view-component.css']
})
export class ImageViewComponent implements OnChanges {
  @Input() kit: Kit;
  @Input() isOpen: boolean = false;
  @Input() statusCountMap: { [key: string]: number } = {};
  @Output() close = new EventEmitter<void>();
  @Output() statusUpdated = new EventEmitter<{ kitId: string, status: string }>();

  selectedImage: string | null = null;
  isImagePopupOpen: boolean = false;
  images: string[] = [];
  previousStatus: string = '';
  status: string = '';

  constructor(private accountService: AccountService, private toaster: ToastrService, private spinner: NgxSpinnerService,) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['kit'] && this.kit) {
      this.fetchImages();
    }
  }

  fetchImages() {
    this.spinner.show();
    if (this.kit && this.kit.id) {
      this.status = this.kit.refImageStatus.toString();
      this.previousStatus = this.kit.refImageStatus.toString();
      this.accountService.getReferenceImages(this.kit.id, this.kit).subscribe(
        (response: { content: { referenceImages: string[] } }) => {
          this.images = response.content.referenceImages || [];
          this.spinner.hide();
        },
        (error) => {
          console.error('Error fetching images:', error);
          this.images = [];
          this.spinner.hide();
        }
      );
    } else {
      this.images = []; 
    }
  }

  updateStatus() {
    this.spinner.show();
    if (!this.kit || !this.kit.id) return;

    this.accountService.updateReferenceImageStatus(this.kit.id, this.status).subscribe(
      (response) => {
        console.log('Status updated successfully:', response);
        this.kit.refImageStatus = this.status;
        this.statusCountMap[this.status] = (this.statusCountMap[this.status] || 0) + 1;
        this.statusCountMap[this.previousStatus] = (this.statusCountMap[this.previousStatus] || 1) - 1;
        this.previousStatus = this.status;

        this.toaster.success('Status updated successfully!', 'Success');
        this.spinner.hide();
      },
      (error) => {
        console.error('Error updating status:', error);
        this.toaster.error('Failed to update status.', 'Error!');
        this.spinner.hide();
      }
    );
  }

  closePopup() {
    this.isOpen = false;
    this.close.emit();
  }

  openImagePopup(imageUrl: string) {
    this.selectedImage = imageUrl;
    this.isImagePopupOpen = true;
  }

  closeImagePopup() {
    this.isImagePopupOpen = false;
    this.selectedImage = null;
  }

  downloadImage() {
    if (this.selectedImage) {
      const link = document.createElement('a');
      link.href = this.selectedImage;
      link.download = 'downloaded_image.jpg';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
}
